<template>
    <div id="app">
        <div v-if="loading" class="page-loader">
            <hollow-dots-spinner :animation-duration="1000" :dot-size="15" :dots-num="3" color="#20409a" />
        </div>
        <div v-else>
            <div v-if="$store.state.loader" class="page-loader">
                <hollow-dots-spinner :animation-duration="1000" :dot-size="15" :dots-num="3" color="#20409a" />
            </div>
            <vue-progress-bar></vue-progress-bar>
            <router-view />
        </div>
    </div>
</template>

<script>
import { HollowDotsSpinner } from 'epic-spinners';

import global from './mixins/global';
import Vue from 'vue';
Vue.mixin(global);
// import axios from 'axios';

export default {
    name: 'app',
    components: {
        HollowDotsSpinner,
    },
    data() {
        return {
            loading: true,
        };
    },
    methods: {
        // async getCurrencies() {
        //   // return console.log('remove');
        //   return;
        //   try {
        //     const res = await axios({
        //       url: `https://api.coinbase.com/v2/exchange-rates`,
        //       method: 'get',
        //       headers: {
        //       },
        //     });
        //     this.$store.commit('set', { currencies: res.data.data.rates })
        //     // console
        //   } catch (err) {
        //     this.catchErrors(err);
        //   }
        // },
    },
    created() {
        this.$Progress.start();
        this.$router.beforeEach((to, from, next) => {
            if (to.meta.progress !== undefined) {
                let meta = to.meta.progress;
                this.$Progress.parseMeta(meta);
            }
            this.$Progress.start();
            next();
        });
        this.$router.afterEach(() => {
            this.$Progress.finish();
        });
    },
    async mounted() {
        // this.getCurrencies();
        setTimeout(() => {
            this.loading = false;
            this.$Progress.finish();
        }, 3000);

        // setInterval(() => {
        //   this.getCurrencies();
        // }, 10000);
    },
};
</script>
<style>
.page-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
/* @font-face {
    font-family: 'BwAletaNo10';
    src: url('~@/assets/kovatek/FONTS/BwAletaNo20-Regular.otf')
        format('opentype'),
      url('~@/assets/kovatek/FONTS/BwAletaNo10-Black.otf') format('opentype'),
      url('~@/assets/kovatek/FONTS/BwAletaNo10-BlackItalic.otf')
        format('opentype'),
      url('~@/assets/kovatek/FONTS/BwAletaNo10-Bold.otf') format('opentype'),
      url('~@/assets/kovatek/FONTS/BwAletaNo10-BoldItalic.otf')
        format('opentype'),
      url('~@/assets/kovatek/FONTS/BwAletaNo10-RegularItalic.otf')
        format('opentype');
    font-weight: normal;
    font-style: normal;
  } */

#app {
    /* font-family: 'BwAletaNo10', Helvetica, Arial, sans-serif; */
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    /* zoom: 90%; */
}
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}
.kova-text {
    color: #20409a;
}
.kovatek-width {
    max-width: 1350px;
    margin: auto;
}
.kovatek-width-1 {
    max-width: 1450px;
    margin: auto;
}
.kova-bg {
    background-color: #20409a;
}

.ant-btn-primary,
.btn-kovatek {
    background-color: #20409a !important;
    color: #fff;
    transition: 0.25s;
    border: solid 1px #20409a !important;
    outline: 0;
}
.ant-btn-primary:hover,
.ant-btn-primary:focus,
.btn-kovatek:hover {
    background-color: #06216d;
    color: #fff;
}

.ant-btn {
    background-color: #fff;
    border-color: #20409a !important;
}

.ant-btn:not([disabled]):active {
    color: #20409a !important;
}

.go-back {
    position: relative;
    top: 2px;
    color: #2db7f5;
    cursor: pointer;
}
.ant-color {
    color: #2db7f5;
}
.pointer {
    cursor: pointer;
}
.add-rounded {
    border-radius: 10px;
}
.kova-id {
    height: 20px;
    background-color: #4bb38e;
    border-radius: 5px;
}
.scrollbar::-webkit-scrollbar {
    background-color: #fff;
    width: 16px;
}
.kova-green {
    color: #4bb38e;
}
.kova-bg-green {
    background-color: #4bb38e;
}
.kova-light {
    color: #ababab;
}
.light-blue {
    background-color: rgba(32, 64, 154, 0.25);
}
.radio {
    position: relative;
    cursor: pointer;
    line-height: 20px;
    font-size: 16px;
    margin: 15px;
}

.label {
    position: relative;
    display: block;
    float: left;
    margin-right: 10px;
    width: 20px;
    height: 20px;
    border: 1px solid #20409a;
    border-radius: 100%;
    -webkit-tap-highlight-color: transparent;
}

.label::after {
    content: '';
    position: absolute;
    top: 4px;
    left: 4px;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background: #20409a;
    transform: scale(0);
    transition: all 0.5s ease;
    opacity: 0.08;
    pointer-events: none;
}

.label:hover + .label::after {
    transform: scale(3.6);
}

button:focus {
    outline: none !important;
}

input[type='radio']:checked + .label {
    border-color: #20409a;
}

input[type='radio']:checked + .label::after {
    transform: scale(1);
    transition: all 0.5s cubic-bezier(0.35, 0.9, 0.4, 0.9);
    opacity: 1;
}
.hidden {
    display: none;
}
/* background of the scrollbar except button or resizer */
.scrollbar::-webkit-scrollbar-track {
    background-color: #fff;
}
.scrollbar::-webkit-scrollbar-track:hover {
    background-color: #f4f4f4;
}

/* scrollbar itself */
.scrollbar::-webkit-scrollbar-thumb {
    /* background-color:#babac0; */
    background-color: #20409a;
    border-radius: 16px;
    border: 5px solid #fff;
}
.scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: #a0a0a5;
    border: 4px solid #f4f4f4;
}
.intermediate {
    color: #acac21;
}

/* styling checkbox */
.checkbox-label {
    display: block;
    position: relative;
    cursor: pointer;
    font-size: 22px;
    line-height: 24px;
    height: 20px;
    width: 100%;
}
.checkbox-label input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.checkbox-label .checkbox-custom {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 21px;
    width: 21px;
    background-color: transparent;
    border-radius: 5px;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
    /* border: 2px solid #20409a; */
    background: linear-gradient(to bottom, #4bb38e, #20409a);
}
.checkbox-label input:checked ~ .checkbox-custom {
    background: linear-gradient(to bottom, #4bb38e, #20409a);
    border-radius: 5px;
    -webkit-transform: rotate(0deg) scale(1);
    -ms-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
    opacity: 1;
    /* border: 2px solid #20409a; */
    border: solid 0;
}
.checkbox-label .checkbox-custom::after {
    position: absolute;
    content: '';
    left: 12px;
    top: 12px;
    height: 0px;
    width: 0px;
    border-radius: 5px;
    border: solid #20409a;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(0deg) scale(0);
    -ms-transform: rotate(0deg) scale(0);
    transform: rotate(0deg) scale(0);
    opacity: 1;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
}
.checkbox-label input:checked ~ .checkbox-custom::after {
    -webkit-transform: rotate(45deg) scale(1);
    -ms-transform: rotate(45deg) scale(1);
    transform: rotate(45deg) scale(1);
    opacity: 1;
    left: 8px;
    top: 3px;
    width: 6px;
    height: 12px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    background-color: transparent;
    border-radius: 0;
}
/* For Ripple Effect */
.checkbox-label .checkbox-custom::before {
    position: absolute;
    content: '';
    left: 10px;
    top: 10px;
    width: 0px;
    height: 0px;
    border-radius: 5px;
    border: 2px solid #20409a;
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    transform: scale(0);
}
.checkbox-label input:checked ~ .checkbox-custom::before {
    left: -3px;
    top: -3px;
    width: 24px;
    height: 24px;
    border-radius: 5px;
    -webkit-transform: scale(3);
    -ms-transform: scale(3);
    transform: scale(3);
    opacity: 0;
    z-index: 999;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
}

.flip-card__top,
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__back::before,
.flip-card__back::after {
    color: #fff !important;
    background: #20409a !important;
    width: 1.8em !important;
    /* font-size: 36px !important; */
}

.flip-clock__piece {
    text-align: center;
}

.vue-tel-input {
    width: 100%;
}

.vue-tel-input .vti__dropdown-list {
    width: 341px;
}

.bid-form .ant-input-number-disabled,
.bid-form input:disabled {
    background: transparent !important;
}

.btn-rounded {
    border-radius: 10px !important;
}

.btn-outline-kovatek {
    border: 1px solid;
}

.project-logo {
    border-radius: 50%;
    height: 41px;
    width: 41px;
}

.ant-radio-inner {
    border-color: #20409a !important;
    padding: 10px !important;
}

.ant-radio-checked .ant-radio-inner {
    border-color: #20409a !important;
}

.ant-checkbox-checked .ant-checkbox-inner {
    border-color: #20409a !important;
    background: #20409a !important;
}

.ant-radio-checked .ant-radio-inner::after {
    background: #20409a !important;
    top: 4px !important;
    left: 4px !important;
    width: 12px !important;
    outline-color: #20409a !important;
    height: 13px !important;
}

#interview .ant-radio-group.ant-radio-group-outline.ant-radio-group-small {
    display: none;
}

.jobTypes .ant-checkbox-group-item {
    display: block;
    margin: 10px !important;
    cursor: pointer;
    line-height: 20px;
    font-size: 16px;
}

.ant-notification-notice-icon {
    background: #fff;
    border-radius: 50%;
    margin-left: 0 !important;
    margin-top: 4px;
    line-height: 16px !important;
}

.toast-class .ant-notification-notice-icon {
    margin-top: 0;
}

.fixed-top {
    z-index: 99 !important;
}

.ant-notification {
    top: 50px;
}

.toast-class .ant-notification-notice-message,
.ant-notification-notice-description,
.ant-notification-notice-message {
    margin-left: 35px !important;
    font-weight: 600;
}

.ant-notification-notice-description,
.toast-class .ant-notification-notice-message {
    color: #fff;
}

.error-class .ant-notification-notice-description {
    color: #000 !important;
}
</style>
